import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.48 9.15">
    <g>
      <path
        fill="#393939"
        d="M11.48,1.14A1.15,1.15,0,0,0,10.33,0H1.15A1.15,1.15,0,0,0,0,1.14V8A1.16,1.16,0,0,0,1.15,9.15h9.18A1.16,1.16,0,0,0,11.48,8Zm-1.15,0L5.74,4,1.15,1.14Zm0,6.86H1.15V2.29L5.74,5.14l4.59-2.85Z"
      />
    </g>
  </svg>,
  `MessageIcon`
);
